import type { RowData } from "@tanstack/react-table";
import { useRecoilValue } from "recoil";

import { isColumnResizable, resolveHeaderColumnWidth } from "@ryde/controls";
import { useReportId } from "@ryde/redux";
import {
  reportsTableColumnWidthSF,
  type IColumnDefMeta,
  type IRydeHeader,
} from "@ryde/shared";

interface IUseGridTableHeadCellReportsParams<T extends RowData> {
  header: IRydeHeader<T, unknown>;
  isTableSized: boolean;
}

export const useGridTableHeadCellReports = <T extends RowData>({
  header,
  isTableSized,
}: IUseGridTableHeadCellReportsParams<T>) => {
  const { reportId } = useReportId();
  const columnId = header.column.id;
  const meta = header.column.columnDef.meta as IColumnDefMeta | undefined;
  const sizedWidth = useRecoilValue(
    reportsTableColumnWidthSF([reportId, columnId]),
  );

  return {
    columnId,
    columnLabel: meta?.displayName,
    columnWidth: resolveHeaderColumnWidth({
      sizedWidth,
      metaWidth: meta?.columnWidth,
      isTableSized,
    }),
    isResizable: !header.isPlaceholder && isColumnResizable(meta),
  };
};
